<script>
  import { onMount } from 'svelte';
  import {
    router,
    useForm,
    page
  } from '@inertiajs/svelte'

  import { slide } from 'svelte/transition'

  import "../../assets/stylesheets/fonts.css"

  //import ElementaryButtons from "../layouts/_elementary_buttons.svelte"
  import Main from "../layouts/_main.svelte"
  import Hero from "./index/_hero.svelte"
  import TranslationQuality from './index/_translation_quality.svelte'
  import FormattingAndLayout from './index/_formatting_and_layout.svelte'
  import PersonalData from './index/_personal_data.svelte'
  import Cta from "./index/_cta.svelte"
  import About from "./index/_about.svelte"
  import FormRow from "../components/_form_row.svelte"
  import LoadingButton from "../components/_loading_button.svelte"

  import {
    configure,
    config,
    root_path,
    translations_path
  } from '../../javascript/routes'

  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"
  import { LANDING_PAGE_TO_EXTENSION } from '../../javascript/constants/landing_pages'

  let { RailsApp, translation, landing_page } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  const form = useForm({
    translation: translation
  })

  onMount(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const targetLanguageId = urlParams.get('target_language_id')

    if (targetLanguageId && RailsApp.Models.Language.ALLOWED_LANGUAGES.find(l => l.id === targetLanguageId)) {
      $form.translation.target_language_id = targetLanguageId
    }
  })

  const allowedTypes = $derived(
    landing_page && LANDING_PAGE_TO_EXTENSION[landing_page]
      ? [LANDING_PAGE_TO_EXTENSION[landing_page]]
      : RailsApp.Models.Translation.ALLOWED_FILE_TYPES
  )
  const maxFileSize = RailsApp.Models.Translation.ALLOWED_MAX_FILE_SIZE
  const maxAdditionalPromptCharacters = RailsApp.Models.Translation.ALLOWED_MAX_ADDITIONAL_PROMPT_CHARACTERS

  function validateFile(file) {
    const extension = file.name.split('.').pop().toLowerCase()
    const isValidType = allowedTypes.includes(extension)
    const isValidSize = file.size <= maxFileSize

    if (!isValidType) {
      $form.errors.source_file = i18n.t('activerecord.errors.models.base.source_file.invalid_file_type', {
        actual_type: extension,
        allowed_types: allowedTypes.join(', ')
      })

      return false
    }

    if (!isValidSize) {
      $form.errors.source_file = i18n.t('activerecord.errors.models.base.source_file.file_too_large', {
        actual_size: i18n.numberToHumanSize(file.size),
        max_size: i18n.numberToHumanSize(maxFileSize)
      })
      return false
    }

    delete $form.errors.source_file
    return true
  }

  function handleFileInput(event) {
    const file = event.target.files[0]

    if(file) {
      $form.translation.source_file = file
      validateFile(file)
    }
    //if (file && validateFile(file)) {
    //  $form.translation.source_file = file
    //} else {
    //  $form.translation.source_file = null
    //}
  }

  function submit(event) {
    event.preventDefault()
    $form.post(translations_path({locale: RailsApp.I18n.locale}))
  }

  let showAdvanced = $state(false);
  //$inspect($form.translation)
  //$inspect(Plans)

  let submitButtonText = $derived(
    ($form.translation.plan_slug === 'free')
      ? i18n.t('Translations.Index.sections.source.cta.translate')
      : i18n.t('Translations.Index.sections.source.cta.check_price')
  );
</script>

<Main {...$page.props}>
  <Hero {RailsApp} {landing_page} />
  <section id="translate" class="container">
    <div class="col-md-7 col-12">
      {#if RailsApp.Models.Translation.DAILY_TOKEN_LIMIT_EXCEEDED}
        <div class="card border-danger mb-4">
          <div class="card-body">
            <span class="card-text text-danger">{i18n.t('Translations.Index.sections.hero.limit')}</span>
          </div>
        </div>
      {/if}
      <form class="container" onsubmit={submit} novalidate  data-bs-spy="scroll" data-bs-target="#nav" data-bs-offset="100" tabindex="0">
        <FormRow>
          {#snippet key()}
          <label class="col-form-label p-0" for="translation_source_file">
            <div class="text-black">{i18n.t('Translations.Index.sections.source.file.key')}</div>
          </label>
          {/snippet}
          {#snippet value()}
          <input
          id="translation_source_file"
          type="file"
          oninput={handleFileInput}
          required
          accept="{allowedTypes.map(type => '.' + type).join(',')}"
          />
          <div class="form-text text-muted">{i18n.t(`landing_pages.${landing_page}.file_description`, {max_file_size: i18n.numberToHumanSize(RailsApp.Models.Translation.ALLOWED_MAX_FILE_SIZE)})}</div>
          {#if $form.errors.source_file}<div class="form-text text-danger fw-bold">{$form.errors.source_file}</div>{/if}
          {/snippet}
        </FormRow>

        <FormRow>
          {#snippet key()}
          <label class="col-form-label p-0" for="translation_target_language_id">
            <div class="text-black">{i18n.t('Translations.Index.sections.source.target_language_id')}</div>
          </label>
          {/snippet}
          {#snippet value()}
          <select aria-label="{i18n.t('Translations.Index.sections.source.target_language_id')}" bind:value={$form.translation.target_language_id} id="translation_target_language_id" size="{1 || RailsApp.Models.Language.ALLOWED_LANGUAGES.length}" required>
            {#each RailsApp.Models.Language.ALLOWED_LANGUAGES as language}
              <option value="{language.id}">{language.name}</option>
            {/each}
          </select>
          {#if $form.errors.target_language_id}<div class="form-text text-danger fw-bold">{$form.errors.target_language_id}</div>{/if}
          {/snippet}
        </FormRow>

        <FormRow>
          {#snippet key()}
          <label class="col-form-label p-0" for="translation_plan_slug">
            <div class="text-black">{i18n.t('Translations.Index.sections.source.plan_slug.title')}</div>
          </label>
          {/snippet}
          {#snippet value()}
          {#each RailsApp.Models.Plan as plan, index}
            <div class="form-check" class:mb-2={index == 0}>
              <input class="form-check-input" type="radio" name="plan_slug" id="translation_plan_slug_{plan.slug}" value="{plan.slug}" bind:group={$form.translation.plan_slug} />
              <label class="form-check-label" for="translation_plan_slug_{plan.slug}">
                {i18n.t(`Translations.Index.sections.source.plan_slug.plans.${plan.slug}.title`, {price: i18n.numberToCurrency(plan.price / 100, {format: '%u%n', unit: '$', precision: 2}), max_characters_per_document: i18n.numberToDelimited(plan.max_characters_per_document)})}
                <small class="d-block mt-1 text-muted">{i18n.t(`Translations.Index.sections.source.plan_slug.plans.${plan.slug}.description`, {max_characters_per_document: i18n.numberToDelimited(plan.max_characters_per_document)})}</small>
              </label>
            </div>
          {/each}
          {/snippet}
        </FormRow>

        <FormRow>
          {#snippet key()}
            {i18n.t('Translations.Index.sections.source.advanced.title')}
          {/snippet}
          {#snippet value()}
          <div
            role="button"
            class="d-inline-flex align-items-center text-muted user-select-none"
            onclick={() => showAdvanced = !showAdvanced}
            >
            <small>
              <i class="bi bi-caret-{showAdvanced ? 'down' : 'right'}-fill me-1"></i>
              {i18n.t('Translations.Index.sections.source.advanced.description')}
            </small>
          </div>
          {#if showAdvanced}
            <div transition:slide class="ps-4">
              <div class="form-group pb-3 mt-3 mb-3 pb-md-4 mb-md-4">
                <label class="form-label text-black" for="translation_target_text_arrangement">{i18n.t('Translations.Index.sections.source.target_text_arrangement.key')}</label>
                <p class="form-text text-muted">{i18n.t('Translations.Index.sections.source.target_text_arrangement.description')}</p>
                {#each RailsApp.Models.Translation.ALLOWED_TARGET_TEXT_ARRANGEMENT_VALUES as key, index}
                  <div class="form-check {index != 2 ? 'mb-2' : 'mb-0'}">
                    <label class="form-check-label" for="target_text_arrangement_{key}">{@html i18n.t(`activerecord.attributes.translation.allowed_target_text_arrangement_values.${key}`)}</label>
                    <input type="radio" class="form-check-input" name="target_text_arrangement" id="target_text_arrangement_{key}" value="{key}" bind:group={$form.translation.target_text_arrangement} />
                  </div>
                {/each}
                {#if $form.errors.target_text_arrangement}<div class="form-text text-danger fw-bold">{$form.errors.target_text_arrangement}</div>{/if}
                  </div>

                  <div class="form-group pb-3 mb-3 pb-md-4 mb-md-4">
                    <label class="form-label text-black" for="translation_additional_prompt">{i18n.t('Translations.Index.sections.source.additional_prompt.key')}</label>
                    <p class="form-text text-muted">{i18n.t('Translations.Index.sections.source.additional_prompt.description', {characters: i18n.numberToDelimited(maxAdditionalPromptCharacters)})}</p>
                    <textarea bind:value={$form.translation.additional_prompt} id="translation_additional_prompt" class="form-control" rows="5" placeholder="{i18n.t('Translations.Index.sections.source.additional_prompt.optional')}" maxlength="{maxAdditionalPromptCharacters}"></textarea>
                    {#if $form.errors.additional_prompt}<div class="form-text text-danger fw-bold">{$form.errors.additional_prompt}</div>{/if}
                      </div>
            </div>
          {/if}
          {/snippet}
        </FormRow>

        <FormRow>
          {#snippet key()}{/snippet}
          {#snippet value()}

          <LoadingButton
            RailsApp={RailsApp}
            processing={$form.processing}
            type="submit"
            aria-label={submitButtonText}
            class="d-block mt-3 elementary-btn elementary-btn-deep-blue"
          >
            {#snippet content()}
              {submitButtonText}
            {/snippet}
          </LoadingButton>
          {/snippet}
        </FormRow>
      </form>
    </div>
  </section>

  <TranslationQuality {RailsApp} />
  <FormattingAndLayout {RailsApp} {landing_page} />
  <PersonalData {RailsApp} />
  <About  {RailsApp}/>
  <Cta  {RailsApp} {landing_page} />
</Main>
